<a
  #copyBtn
  *ngIf="contentToCopy"
  class="copy-btn"
  (click)="copyTextToClipboard()"
>
  {{ copyText }}
</a>
